import { AxiosInstance, AxiosResponse } from "axios";
import {
  UnicoCreateProcessDTO,
  UnicoCreateProcessResponse,
  UnicoDocumentProcessResponse,
  UnicoEvidenceSetResponse,
  UnicoGetSelfieResponse
} from "../entities/Unico";
import useAuthStore from "@repo/core/stores/auth";
import { NEW_API_URL } from "@repo/core/constants/global";

const resource = "unico";

export class UnicoResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async authenticate(): Promise<
    AxiosResponse<{
      access_token: string;
    }>
  > {
    const { user } = useAuthStore.getState();
    const userToken = user?.token || process.env.TEST_TOKEN;
    return this.apiProvider.post("/unico/auth", undefined, {
      baseURL: NEW_API_URL,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`
      }
    });
  }

  async createProcess(
    data: UnicoCreateProcessDTO
  ): Promise<AxiosResponse<UnicoCreateProcessResponse>> {
    return this.apiProvider.post<UnicoCreateProcessResponse>(
      `${resource}/process`,
      data
    );
  }

  async getProcess(
    processId: string
  ): Promise<AxiosResponse<UnicoCreateProcessResponse>> {
    return this.apiProvider.get<UnicoCreateProcessResponse>(
      `${resource}/process/${processId}`
    );
  }

  async getProcessDocuments(
    processId: string
  ): Promise<AxiosResponse<UnicoDocumentProcessResponse>> {
    return this.apiProvider.get<UnicoDocumentProcessResponse>(
      `${resource}/process/${processId}/documents`
    );
  }

  async getSelfie(
    processId: string
  ): Promise<AxiosResponse<UnicoGetSelfieResponse>> {
    return this.apiProvider.get<UnicoGetSelfieResponse>(
      `${resource}/process/${processId}/selfie`
    );
  }

  async getEvidenceSet(
    processId: string
  ): Promise<AxiosResponse<UnicoEvidenceSetResponse>> {
    return this.apiProvider.get<UnicoEvidenceSetResponse>(
      `${resource}/process/${processId}/evidenceset`
    );
  }
}
